<template>
  <div>
    <nav-list></nav-list>

    <!-- 主要内容 -->
    <div class="dowebok" id="dowebok" :class="rightpanelactive ? 'right-panel-active' : ''">
      <div class="form-container sign-up-container">
        <form action="#">
          <h1 style="margin-bottom: 20px;">注册</h1>
          <div class="social-container">
            <!-- <a href="" class="lbtn btn-1"><img src="../assets/images/qqico.png" width="25"></a> -->
            <!-- <a href="#" class="lbtn btn-1"><img src="../assets/images/wbico.png" width="30"></a> -->
            <!-- <a href="#" class="lbtn btn-1"><img src="../assets/images/wxico.png" width="30"></a> -->
          </div>
          <!-- <span>或使用邮箱注册</span> -->
          <div class="register-ipt"><input type="text" v-model="loginName" placeholder="账号名称" @blur="checkName"></div>
          <div class="register-ipt flex"><input type="text" v-model="mobileNum" placeholder="手机号">
            <div class="shou" @click="sendcode">发送验证码</div>
          </div>
          <div class="register-ipt"><input type="text" v-model="code" placeholder="验证码"></div>
          <div class="register-ipt"><input type="password" v-model="passWord" placeholder="密码"></div>
          <div class="zsyy flex flex-x-s"><input class="mr-1011" type="checkbox" :checked="isRead"
              @change="changeread">我同意并遵守<router-link :to="{ path: 'about?id=12&name=版权声明' }">《图片安徽网站服务协议》</router-link>
          </div>
          <div @click="sureRegister" class="button">注册</div>
        </form>
      </div>
      <div class="form-container sign-in-container">
        <form action="#">
          <h1 style="margin-bottom: 20px;">登录</h1>
          <div class="social-container">
            <!-- <a href="javascript:;" class="lbtn btn-1"><img src="../assets/images/qqico.png" width="25"></a> -->
            <!-- <a href="#" class="lbtn btn-1"><img src="../assets/images/wbico.png" width="30"></a> -->
            <a href="javascript:;" @click="authorization('WeiXin')" class="lbtn btn-1"><img
                src="../assets/images/wxico.png" width="30"></a>
          </div>

          <!-- <span>或使用您的帐号</span> -->
          <div class="register-ipt"><input type="text" v-model="loginName1" placeholder="账号"></div>
          <div class="register-ipt"><input type="password" v-model="passWord1" placeholder="密码"></div>
          <router-link class="forget" to="/forget">忘记密码？</router-link>
          <div class="button mt-20" @click="sureLogin">登录</div>
        </form>
      </div>
      <div class="overlay-container">
        <div class="overlay">
          <div class="overlay-panel overlay-left">
            <img src="../assets/images/logo1.png" style="margin-bottom:20px;">
            <h1>已有帐号？</h1>
            <p>请使用您的帐号进行登录</p>
            <button class="ghost button" id="signIn" @click="changeLogin(false)">登录</button>
          </div>
          <div class="overlay-panel overlay-right">
            <img src="../assets/images/logo1.png" style="margin-bottom:20px;">
            <h1>没有帐号？</h1>
            <p>立即注册加入图片安徽，千万正版素材。</p>
            <button class="ghost button" id="signUp" @click="changeLogin(true)">注册</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import navList from './header_nav.vue'
export default {
  data() {
    return {
      rightpanelactive: false,
      sencKey: "", // 加密秘钥
      isCrypt: 0, // 是否加密
      loginName: "",
      mobileNum: "",
      code: "",
      passWord: "",
      isRead: false,
      loginName1: "",
      passWord1: "",
    }
  },

  components: {
    navList
  },

  created() {
    this.isenCrypt() // 是否加密
  },

  methods: {
    changeLogin(state) {
      this.rightpanelactive = state
    },

    // 检车是否开启加密
    async isenCrypt() {
      let _this = this
      const res = await _this.get('/user/getPlatConfig.do', { appID: 1, project: "是否开启加密", item: "IS_ENCRYPTION" })
      _this.isCrypt = res.data
      if (res.data == 1) {
        _this.getsencKey() // 如果加密需要
      }
    },

    // 获取加密秘钥
    async getsencKey() {
      let _this = this
      const res = await _this.get('/getPublishKey.do')
      _this.sencKey = res.data
    },

    // 失去焦点验证名称是否可用
    async checkName() {
      let _this = this
      if (_this.loginName == '') {
        return
      }
      const res = await _this.get('/user/checkUserInfo.do', { checkText: _this.loginName, checkType: 1 })

      if (res.result == 1) {
        this.$Message.success({
          content: res.data,
          duration: 3
        });
      }
      if (res.result == 0) {
        this.$Message.error({
          content: res.error.errorMsg,
          duration: 5,
          closable: true
        });
      }
    },

    // 发送验证吗 - 验证手机号
    async sendcode() {
      let _this = this
      if (!_this.util.isMobile(_this.mobileNum)) {
        return _this.$Message.error('请输入正确手机号')
      }
      var res = await _this.get('/user/checkUserInfo.do', { checkText: _this.mobileNum, checkType: 3 })
      if (res.result == 0) {
        return _this.$Message.error({
          content: res.error.errorMsg,
          duration: 5,
          closable: true
        });
      }
      // 上面是验证手机号是否可用 下面发送验证码
      const res1 = await _this.get('/user/sendMobileMessage1.do', { mobileNum: _this.mobileNum, isRegister: true })
      if (res1.result == 1) {
        this.$Message.success({
          content: '发送成功，请等待短信提示',
          duration: 3
        });
      }
    },

    // 确认注册
    async sureRegister() {
      let _this = this
      if (!_this.isRead) {
        return this.$Message.warning({
          content: '请选阅读并勾选同意服务协议',
          duration: 3
        });
      }
      let { code, loginName, passWord, mobileNum } = _this
      const res = await _this.get('/user/checkCodeAndLogin.do', { isRegister: true, code, loginName, passWord, mobileNum })
      if (res.result == 1) {
        this.$Message.success({
          content: res.data,
          duration: 3
        });
        setTimeout(() => {
          window.location.reload()
        }, 3000)
      }
      if (res.result != 1) {
        this.$Message.error({
          content: res.error.errorMsg || '请求出错',
          duration: 5,
          closable: true
        });
      }
    },

    // 改变阅读协议状态
    changeread(e) {
      // console.log()
      this.isRead = e.target.checked
    },

    // 确认登录
    async sureLogin() {
      let _this = this
      _this.$Spin.show()
      let data = {
        loginName: _this.loginName1,
        password: _this.passWord1,
        flag: 'pc'
      }
      const res = await _this.post('/loginNew.do', data)
      _this.$Spin.hide()
      if (res.result == 1) {
        this.$Message.success({
          content: "登录成功",
          duration: 3
        });

        localStorage.setItem('token', res.token)
        localStorage.setItem('authorStatus', res.data.authorStatus)
        setTimeout(() => {
          _this.$router.replace({ path: '/index' })
        }, 3000)
      }
      if (res.result == 0) {
        this.$Message.error({
          content: res.error.errorMsg,
          duration: 5,
          closable: true
        });
      }
    },

    // 授权登录
    // http://www.tpahw.com
    async authorization(loginType) {
      let _this = this
      let data = {
        loadingUrl: encodeURI(_this.$baseURL + '/addPhone'),
        loginType,
      }
      const res = await _this.post('/v2/auth/authUrl.do', data)
      window.location.href = res.data.data
    }
  },

}
</script>

<style lang="less" scoped>
.forget {
  margin: 2px auto;
  color: #000FFF !important;
}

* {
  box-sizing: border-box;
}

body {
  font-family: 'Montserrat', sans-serif;
  background: #f6f5f7;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;

}

h1 {
  font-weight: bold;
  margin: 0;
}

p {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: .5px;
  margin: 20px 0 30px;
}

span {
  font-size: 12px;
}

a {
  color: #333;
  font-size: 14px;
  text-decoration: none;
  margin: 15px 0;
}

.dowebok {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, .25), 0 10px 10px rgba(0, 0, 0, .22);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  width: 768px;
  max-width: 100%;
  min-height: 480px;
}

.form-container form {
  background: #fff;
  display: flex;
  flex-direction: column;
  padding: 0 50px;
  height: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.social-container {
  margin: 20px 0;
}

.social-container a {

  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 5px;
  height: 55px;
  width: 55px;
}

.social-container a:hover {
  background-color: #eee;
}

.form-container .register-ipt {
  background: #eee;
  border: none;
  padding: 12px 15px;
  margin: 8px 0;
  width: 100%;
  outline: none;
  display: flex;
}

.form-container .register-ipt input {
  flex: 1;
}

.button {
  border-radius: 20px;
  border: 1px solid #ff4b2b;
  background: #ff4b2b;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  padding: 12px 45px;
  letter-spacing: 1px;
  text-transform: uppercase;
  transition: transform 80ms ease-in;
  cursor: pointer;
}

button:active {
  transform: scale(.95);
}

button:focus {
  outline: none;
}

button.ghost {
  background: transparent;
  border-color: #fff;
}

.form-container {
  position: absolute;
  top: 0;
  height: 100%;
  transition: all .6s ease-in-out;
}

.sign-in-container {
  left: 0;
  width: 50%;
  z-index: 2;
}

.sign-up-container {
  left: 0;
  width: 50%;
  z-index: 1;
  opacity: 0;
}

.overlay-container {
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: 100%;
  overflow: hidden;
  transition: transform .6s ease-in-out;
  z-index: 100;
}

.overlay {
  background: #1495f0;
  background: linear-gradient(to right, #086db4, #2fa0ef) no-repeat 0 0 / cover;
  color: #fff;
  position: relative;
  left: -100%;
  height: 100%;
  width: 200%;
  transform: translateY(0);
  transition: transform .6s ease-in-out;
}

.overlay-panel {
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 40px;
  height: 100%;
  width: 50%;
  text-align: center;
  transform: translateY(0);
  transition: transform .6s ease-in-out;
}

.overlay-right {
  right: 0;
  transform: translateY(0);
}

.overlay-left {
  transform: translateY(-20%);
}

/* Move signin to right */
.dowebok.right-panel-active .sign-in-container {
  transform: translateY(100%);
}

/* Move overlay to left */
.dowebok.right-panel-active .overlay-container {
  transform: translateX(-100%);
}

/* Bring signup over signin */
.dowebok.right-panel-active .sign-up-container {
  transform: translateX(100%);
  opacity: 1;
  z-index: 5;
}

/* Move overlay back to right */
.dowebok.right-panel-active .overlay {
  transform: translateX(50%);
}

/* Bring back the text to center */
.dowebok.right-panel-active .overlay-left {
  transform: translateY(0);
}

/* Same effect for right */
.dowebok.right-panel-active .overlay-right {
  transform: translateY(20%);
}

.lbtn {
  float: left;
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
  background: #00a1d6;
  box-shadow: 0 4px 4px rgba(127, 127, 127, .3);
  display: inline-block;
  color: #fff;
  font-size: 12px;
  border-radius: 4px;
  transition: all 0.2s;
  margin: 0 0 5px 15px;
}

.btn-1:hover {
  background: #00b5e5;
  text-decoration: none;
}

.btn-2:hover {
  filter: brightness(1.1);
}

.zsyy {
  font-size: 12px;
  float: left;
}

.zsyy a {
  color: #0099ff;
  font-size: 12px;
}

.zsyy a:hover {
  color: #ff3300;
}




/*====================导航*********/
.header {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  height: 80px;
  padding: 15px 30px;
  background: rgba(28, 35, 39, 0.7);
  box-shadow: 0 4px 4px rgba(127, 127, 127, .3);
}

/*左侧logo*/
.header .left {
  float: left;
  width: 12%;
}

.header .left a img {
  height: 50px;

}

.header .left .img2 {
  display: none;
}

/*右侧*/
.header .nav {
  width: 80%;
  float: right;
  -webkit-transition: 0.5s;
  -moz-transition: 0.5s;
  -o-transition: 0.5s;
  transition: 0.5s;
  height: 100%;
  line-height: 50px;
  display: block;
}

.header .navbar_nav li {
  float: left;
  position: relative;
  display: block;
}

.header .navbar_nav li:after {
  content: "";
  width: 0;
  height: 2px;
  background: orangered;
  position: absolute;
  bottom: 0;
  left: 0;
  transition: all 0.5s ease 0s;
}

.header .navbar_nav li:hover:after {
  width: 100%;
}

.header .navbar_nav li a {
  text-decoration: none;
  height: 100%;
  padding: 0 15px;
  display: block;
  -webkit-transition: 0.5s;
  -moz-transition: 0.5s;
  -o-transition: 0.5s;
  transition: 0.5s;
  color: #fff;
  font-size: 16px;
}

.header .navbar_nav li:hover a {
  color: orangered;
}

.header .navbar_nav li.dropdown {
  display: inherit;
  position: relative;
}

.header .navbar_nav li.dropdown .jt {
  width: 20px;
  height: 20px;
  // background: url(i/top.png) no-repeat;
  background-size: 100% 100%;
  display: block;
}

.header .navbar_nav li.dropdown .dropdown_menu {
  display: none;
  position: absolute;
  top: 50px;
  width: 100%;
  background: #fff;
  box-shadow: 0 15px 27px 0 rgba(167, 165, 165, 0.38);
  width: 120%;
  left: -10%;
}

.header .navbar_nav li.dropdown .dropdown_menu a {
  font-size: 14px;
  color: #666;
  padding: 0 10px;
  line-height: 40px;
  text-align: center;
  background: #fff;
  margin-bottom: 2px;
}

.header .navbar_nav li.dropdown:hover .dropdown_menu {
  display: block;
  background: #f3f3f3;
  -webkit-transition: 0.5s;
  -moz-transition: 0.5s;
  -o-transition: 0.5s;
  transition: 0.5s;
}

.header .navbar_nav li.dropdown:hover .dropdown_menu a {
  color: #666;
}

.header .navbar_nav li.dropdown:hover .dropdown_menu a:hover {
  color: #fff;
  background: #00a1d6;
}

.lbtn {
  float: left;
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
  background: #00a1d6;
  box-shadow: 0 4px 4px rgba(127, 127, 127, .3);
  display: inline-block;
  color: #fff;
  font-size: 12px;
  border-radius: 4px;
  transition: all 0.2s;
  margin: 0 0 5px 15px;
}

.btn-1:hover {
  background: #00b5e5;
  text-decoration: none;
}

.btn-2:hover {
  filter: brightness(1.1);
}

/*白色背景的头部*/
.header.on {
  background: #fff;
  border-bottom: 1px solid #ccc;
}

.header.on .left .img1 {
  display: none;
}

.header.on .left .img2 {
  display: block;
}

.header.on .navbar_nav li a {
  color: #333;
}

.header.on .navbar_nav li:hover a {
  color: orangered;
}

.mr-1011 {
  margin: 0 6px 0 0 !important;
}

.footer {
  font-size: 12px;
  color: #999999;
  margin-top: 50px;
  text-align: center;
  line-height: 25px;
}
</style>
